var map = {
	"./avatar0.jpg": "3542",
	"./avatar1.jpg": "d299",
	"./avatar2.jpg": "d4d6",
	"./avatar3.jpg": "def4",
	"./avatar4.jpg": "6bd3",
	"./avatar5.jpg": "e879",
	"./avatar6.jpg": "85e1",
	"./avatar7.jpg": "164d",
	"./avatar8.jpg": "0fd8",
	"./avatar9.jpg": "6c20",
	"./avatar_f.jpg": "0c2c",
	"./avatar_m.jpg": "a022"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3280";